var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwitchRefresh = function SvgSwitchRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -41.18,
    y1: 210.42,
    x2: 191.9,
    y2: 77.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -65.51,
    y1: 167.85,
    x2: 167.58,
    y2: 34.66,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M164,23.11h10.64c2.12,0,3.83-1.71,3.83-3.83s-1.71-3.83-3.83-3.83h-24.32v23.31c0,2.12,1.71,3.83,3.83,3.83s3.83-1.72,3.83-3.83v-10.73s.08.08.13.11c21.85,17.64,34.38,43.84,34.38,71.9,0,50.91-41.42,92.34-92.34,92.34-2.12,0-3.83,1.71-3.83,3.83s1.71,3.83,3.83,3.83h0c55.14,0,100-44.86,99.99-100,0-29.9-13.16-57.85-36.13-76.93Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.57,160.49c-2.12,0-3.83,1.71-3.83,3.83v11.06C22.32,158.04,7.81,130.07,7.81,100.04,7.81,49.12,49.22,7.69,100.14,7.69c2.12,0,3.83-1.71,3.83-3.83S102.26.04,100.14.04C45.01.04.16,44.9.16,100.04c0,31.58,14.83,61.07,39.91,79.93h-9.98c-2.12,0-3.83,1.71-3.83,3.83s1.71,3.83,3.83,3.83h24.32v-23.31c0-2.12-1.71-3.83-3.83-3.83Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }));
};
export default SvgSwitchRefresh;